import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import {
  defaultPasscodeTheme,
  switchControl,
  selectField,
  getSelectValues,
  getSelectedValueTranslated,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";

import {
  PASSWORD_VALID_WITH_COUNT,
  FIRST_PARTY_ON_HOLD,
  PARTICIPANT_NAME_RECORD,
  PLAY_FIRST_CALLER_MESSAGE,
  CONFERENCE_QUICK_START,
  DOUBLE_PASSCODE_ENTRY,
  CONFERENCE_LEVEL_PASSCODE,
} from "../../../utils/responseValue";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
}));

const PMEntry = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const classes = useStyles();

  const handleSwitchChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.checked });
  };
  const handleSelectChange = name => event => {
    setConfRestRep({
      ...confRestRep,
      [name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = theme => ({
    formControl: {
      width: "250px",
    },
  });

  return (
    <form className={classes.container} noValidate autoComplete="off">
      {switchControl(
        classes,
        confRestRep[PLAY_FIRST_CALLER_MESSAGE],
        PLAY_FIRST_CALLER_MESSAGE,
        translate[PLAY_FIRST_CALLER_MESSAGE],
        handleSwitchChange(PLAY_FIRST_CALLER_MESSAGE)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[PASSWORD_VALID_WITH_COUNT],
        PASSWORD_VALID_WITH_COUNT,
        translate[PASSWORD_VALID_WITH_COUNT],
        handleSwitchChange(PASSWORD_VALID_WITH_COUNT)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[PARTICIPANT_NAME_RECORD],
        PARTICIPANT_NAME_RECORD,
        translate[PARTICIPANT_NAME_RECORD],
        handleSwitchChange(PARTICIPANT_NAME_RECORD)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[CONFERENCE_QUICK_START],
        CONFERENCE_QUICK_START,
        translate[CONFERENCE_QUICK_START],
        handleSwitchChange(CONFERENCE_QUICK_START)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[FIRST_PARTY_ON_HOLD],
        FIRST_PARTY_ON_HOLD,
        translate[FIRST_PARTY_ON_HOLD],
        handleSwitchChange(FIRST_PARTY_ON_HOLD)
      )}
      <div className={classes.lineBreak} />
      {selectField(
        customStyle,
        translate[DOUBLE_PASSCODE_ENTRY],
        getSelectValues(selectValues, DOUBLE_PASSCODE_ENTRY),
        getSelectedValueTranslated(confRestRep[DOUBLE_PASSCODE_ENTRY], selectValues, DOUBLE_PASSCODE_ENTRY),
        handleSelectChange(DOUBLE_PASSCODE_ENTRY)
      )}
      <div className={classes.lineBreak} />
      {selectField(
        customStyle,
        translate[CONFERENCE_LEVEL_PASSCODE],
        getSelectValues(selectValues, CONFERENCE_LEVEL_PASSCODE),
        getSelectedValueTranslated(confRestRep[CONFERENCE_LEVEL_PASSCODE], selectValues, CONFERENCE_LEVEL_PASSCODE),
        handleSelectChange(CONFERENCE_LEVEL_PASSCODE)
      )}
    </form>
  );
};

PMEntry.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMEntry;
